import { createFileRoute } from "@tanstack/react-router";
import { TemplateDetail } from "@/modules/proposal-builder/components/templates/TemplateDetail";

export const Route = createFileRoute("/proposal-builder/templates/$id")({
  component: ProposalTemplateDetailRoute,
});

function ProposalTemplateDetailRoute() {
  const { id } = Route.useParams();

  return <TemplateDetail id={id} />;
}